import React from 'react';
import Link from 'components/Link';
import { convertHtmlToStringText } from 'utils/common';
import Icon from './Icon';
import s from './Linkitem.scss';

const getGAData = (gaData, data) => {
  if (!gaData || typeof gaData !== 'string') {
    return '';
  }

  let type = 'Article';
  if (data.type === 'video' || data.tn === 'video') {
    type = 'Video';
  } else if (data.type === 'photostory' || data.tn === 'photostory') {
    type = 'Photo';
  }

  const updatedGAData = gaData.replace('$type', type);
  // updatedGAData = `${updatedGAData}${data.wu ? data.wu : ''}`;
  return updatedGAData;
};

const LinkItem = props => {
  const {
    item = { hasVideo: '', cs: '', tn: '' },
    showIcon = true,
    showBlinker = true,
    htmlKeys,
    linkType2,
    sendGAEvent,
    ga4Type,
    gaIndex,
    ...restProps
  } = props;
  let iconType;
  if (item.cs) {
    iconType = 'toiplus';
  } else if (item.tn === 'photostory') {
    iconType = item.tn;
  } else if (item.hasVideo === 'yes' || item.tn === 'video') {
    iconType = 'video';
  }

  return (
    <Link
      to={item.wu}
      {...restProps}
      data-newga={getGAData(restProps.newGA || '', item)}
      //onClick={() => sendGAEvent(item.hl)}
      ga4Data={
        ga4Type
          ? [
              {
                event: 'user_click',
                type: `${ga4Type}`,
                category: 'story_click',
                story_no: `${gaIndex}`,
                msid: item?.id,
              },
            ]
          : !!restProps.ga4Data && [
              {
                ...restProps.ga4Data,
                label:
                  htmlKeys &&
                  htmlKeys instanceof Array &&
                  htmlKeys.indexOf('hl') > -1
                    ? convertHtmlToStringText(item.hl)
                    : item.hl,
              },
            ]
      }
      target={item.target === '_blank' ? item.target : ''}
    >
      <>
        {showBlinker && item.tn === 'liveblog' ? (
          <div className={`${s.liveBtn} ${s.red} ${linkType2 && s.type2} `} />
        ) : (
          ''
        )}
        <span>
          {/* {typeof item.titlePrefix !== 'undefined' && (
            <small className="toiPlusTag">{item.titlePrefix}:</small>
          )} */}
          {htmlKeys && htmlKeys instanceof Array && htmlKeys.indexOf('hl') > -1
            ? convertHtmlToStringText(item.hl)
            : item.hl}
        </span>
        {showIcon && <Icon test="1" type={iconType} />}
      </>
    </Link>
  );
};
export default LinkItem;
